export enum ETruckType {
    'VAN' = 'VAN',
    'DUMP_TRUCK' = 'DUMP TRUCK',
    'BOX_TRUCK' = 'BOX TRUCK',
    'REEFER' = 'REEFER',
}

export enum EInvitationStatus {
    'PENDING' = 'pending',
    'ACTIVATED' = 'activated',
}
export enum EUserRoles {
    'ADMIN' = 'admin',
    'SUB-ADMIN' = 'sub-admin',
}
